import { PrivacyRoute } from '@Core/Routes/PrivacyRoute'
import { PurchasingRoles } from '@Purchasing/index'
import { RoutesPaths } from '@Purchasing/RoutesPaths'
import { NewPurchaseProcess } from '@Purchasing/NewPurchaseProcess/NewPurchaseProcess'
import { PurchaseProcessDetails } from '@Purchasing/PurchaseProcessDetails/PurchaseProcessDetails'
import { PurchaseProcessList } from '@Purchasing/PurchaseProcessList/PurchaseProcessList'
import { PurchasingSupplierList } from '@Purchasing/Suppliers/PurchasingSupplierList'
import { PurchasingReports } from '@Purchasing/Reports/PurchasingReports'
import { Route } from 'react-router-dom'

const router = [
    <Route key={'PurchasingStack'} path="/">
        <Route
            element={
                <PrivacyRoute
                    permission={PurchasingRoles.process.permissions.read.key}
                />
            }
        >
            <Route
                path={RoutesPaths.PurchasingList}
                element={<PurchaseProcessList />}
            />
            <Route
                path={RoutesPaths.PurchasingNew}
                element={<NewPurchaseProcess />}
            />
            <Route
                path={RoutesPaths.PurchasingDetail}
                element={<PurchaseProcessDetails />}
            />
            <Route
                path={RoutesPaths.PurchasingSuppliers}
                element={<PurchasingSupplierList />}
            />
        </Route>
        <Route element={<PrivacyRoute permission={PurchasingRoles.report.permissions.read.key} />}>
            <Route path={RoutesPaths.PurchasingReports} element={<PurchasingReports />} />
        </Route>
    </Route>,
]
export default router
